<template>
    <div class="ex_list pt10" :class="{inline}">
        <vuedraggable :list="dataList" dataIdAttr="data-id" :disabled="!dragable">
            <div class="ex_item br6" :class="{mb24: !inline, active: !isSelect && item.checked}" v-for="(item,k) in dataList" :key="k+'exer'" @click.stop="clickItem(item)">
                <cl-card :item="item">
                    <cl-tag-group v-if="item.tags" class="taglist mt4" :list="item.tags.slice(0,3)" view="simple">
                    </cl-tag-group>
                    <p v-if="item.tags" class="time mt8 fs12 Gray_Color AkrobatR">
                        {{$moment(item.createTime).format('YYYY/MM/DD HH:mm')}}</p>
                </cl-card>
                <div class="checked" v-if="isSelect">
                    <el-checkbox style="width: 24px; height:24px;" @change="clickItem(item)" class="Custom_Check Br4_Check" v-model="item.checked"></el-checkbox>
                </div>
                <div class="delete br4" @click.stop="handleDelete(item)" v-if="isDelete"></div>
                <div class="masker" v-show="item.checked && isSelect"></div>
            </div>
        </vuedraggable>
        <cl-no-data v-if="dataList.length === 0"></cl-no-data>
    </div>
</template>

<script>
    /**
     * ComponentName: 列表(exercise & formation)
     * Created Date:2022/4/29
     * Author: Nancy
     * 组件说明：
     * 此组件是满足阵型库和教案库列表UI展示，以及选中效果，删除功能
     * mode: 组件的模式，选择(select)勾选、取消选择，删除(delete)选择的教案
     * eg:
     *     <cl-card-list v-model="list"></cl-card-list>
     */
    import vuedraggable from "vuedraggable";
    export default {
        name: 'cl-card-list',
        data() {
            return {
                selectedList: this.value || [], // 选择的数据
                dataList: [], // 所有数据列表
                dragIndex: -1, // -1 代表未拖拽
            };
        },
        components: {
            vuedraggable
        },
        model: {
            prop: 'value',
            event: 'change'
        },
        props: {
            value: {
                type: Array,
                default: () => []
            },
            list: {
                type: Array,
                default: () => []
            },
            mode: {
                type: String,
                default: 'select'
            },
            inline: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'single'
            },
            dragable: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            // 选择模式
            isSelect() {
                return this.mode === 'select';
            },
            // 删除模式
            isDelete() {
                return this.mode === 'delete';
            },
            // 浏览模式
            isView() {
                return this.mode === 'view';
            },
            // 多选
            isMutiple() {
                return this.type === 'multiple'
            },
            // 单选
            isSingle() {
                return this.type === 'single'
            }
        },
        watch: {
            value: {
                handler() {
                    this.selectedList = JSON.parse(JSON.stringify(this.value));
                },
                deep: true,
            },
            list: {
                handler() {
                    this.initData();
                },
                deep: true,
            }
        },
        mounted() {
            this.initData();
        },

        methods: {
            // 初始化数据
            initData() {
                this.dataList = this.list.map(item => {
                    return {
                        ...item,
                        image: item.drawingThumbnail || item.image,
                        name: item.title || item.name,
                        checked: this.isChecked(item)
                    }
                })
            },
            // 是否选择
            isChecked(item) {
                let itm = this.value.find(el => el.id === item.id);
                return itm ? true : false;
            },
            // 选择、取消
            handleChange(item) {
                if (this.isMutiple) { // 多选
                    let i = this.selectedList.findIndex(el => el.id === item.id);
                    if (item.checked) {
                        if (i === -1) this.selectedList.push(item);
                    } else {
                        if (i !== -1) this.selectedList.splice(i, 1);
                    }
                }
                if (this.isSingle) { // 单选
                    this.dataList.forEach(el => {
                        if (el.id !== item.id) el.checked = false;
                    });
                    this.selectedList = [item];
                }
                this.$emit('change', this.selectedList);
            },
            // 点击教案
            clickItem(item) {
                item.checked = !item.checked;
                this.$emit('click', item);
                this.handleChange(item);
            },
            // 删除教案
            handleDelete(item) {
                this.$emit('delete', item);
            }
        }
    }
</script>
<style lang='scss' scoped>
    .ex_list {
        width: 100%;
        height: 100%;
        overflow: auto;
        box-sizing: border-box;

        .ex_item {
            width: 172px;
            height: 290px;
            display: inline-flex;
            flex-direction: column;
            margin-right: 20px;
            box-sizing: border-box;
            position: relative;
            cursor: pointer;

            &:nth-child(5n) {
                margin-right: 0;
            }

            .checked {
                position: absolute;
                top: -4px;
                right: -4px;
                z-index: 5;
            }

            .delete {
                @extend .checked;
                width: 24px;
                height: 24px;
                background: url('../../assets/images/exercise/delete.png') no-repeat;
                background-size: 100% 100%;
                opacity: 0;
            }

            .taglist {
                display: none;
            }

            .time {
                display: none;
            }

            .masker {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: #0F0F17;
                opacity: 0.3;
                border-radius: 6px;
                z-index: 4;
            }

            &.active,
            &:hover {
                .videos {
                    background-color: $base-color-theme;
                }

                .delete {
                    opacity: 1;
                }

                .taglist,
                .time {
                    display: block;
                }

                /deep/.cl_card {
                    .cl_card_img {
                        height: 200px;
                    }

                    .cl_card_animation {
                        background: #3663E1;
                    }

                    .card_name {
                        display: block;
                    }

                    &::before {
                        content: ' ';
                        display: block;
                    }
                }
            }
        }
    }

    .inline {
        white-space: nowrap; // 空白处理，不换行
        // overflow: hidden;

        .ex_item {
            &:nth-child(5n) {
                margin-right: 20px;
            }
        }
    }
</style>
